import state from './state'

export default {
  isPreparingApp(): boolean {
    return state.loading || state.initializing
  },
}
